import type { FieldMatcher } from '@cdw-ae/filter-bar-interfaces';

export const IsMatcher: FieldMatcher = {
  name: 'is',
  displayName: 'is',
  hasEditor: true,
  options: {
    setValue: (value): string => String(value),
    chipFormatter: (value: string): string =>
      `: ${String(value).charAt(0).toUpperCase() + String(value).slice(1)}`,
  },
  editorOptions: {
    selectionOptions: [{ name: 'missing', displayName: 'Missing' }],
  },
};
